import React, { Component } from "react";
import {Helmet} from "react-helmet";
import PageBack from "../../Assets/Images/pageBack.png";

//fund support
import MCRDIcon from "../../Assets/Images/getInvolved/mcrdIcon.png";
import RHBIcon from "../../Assets/Images/getInvolved/rhbIcon.png";
import QRCode from "../../Assets/Images/getInvolved/qrcode.png";
import DuitNowIcon from "../../Assets/Images/getInvolved/duitNowIcon.png";
import QRPayIcon from "../../Assets/Images/getInvolved/qrpayIcon.png";
import TngIcon from "../../Assets/Images/getInvolved/tngIcon.png";
import BoostIcon from "../../Assets/Images/getInvolved/boostIcon.png";
import ShopeeIcon from "../../Assets/Images/getInvolved/shopeeIcon.png";

import Language from "../languageComponent/language";
//const fontColor = {eng:"#171d22", chi:"#171d22"};

class GetInvolved extends Component {
  constructor(props) {
    super(props);
    this.state = { dimensions: {}, screenDimensions: {} };
    this.onImageLoad = this.onImageLoad.bind(this);
    setInterval(this.swapImages, 3000);
  }
  componentDidUpdate() {
    if (this.props.scrollPos > 0) {
      window.scrollTo(0, this.props.scrollPos);
    }
  }
  render() {
    return (
      <div className="container-fluid">
        <Helmet>
          <title>CAC MCRD Get Involved</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/GetInvolved"} />
          <meta property="og:type" content={"organization infomation"} />
          <meta property="og:title" content={">CAC MCRD Get Involved"} />
          <meta property="og:description" content={"Get involved with CAC MCRD."} />
          <meta property="og:image" content={MCRDIcon} />
        </Helmet>
        <div className="background-image">
          <img
            onLoad={this.onImageLoad}
            style={{
              width: "100%",
              height: "100%",
            }}
            src={PageBack}
          />
        </div>
        <div className="blue-back" />
        <div className="site-content">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div className="prayer-support">
              <p className="prayer-support-title" style={{ position: "relative", width: "100%", fontWeight: "bold", fontSize: "30px", textAlign: "left" }}>
                <Language language={this.props.language} section="prayerSupportTitle" />
              </p>
              <p className="prayer-support-subtitle" style={{ position: "relative", width: "100%", fontWeight: "bold", fontSize: "15px", textAlign: "left", top: "-15px", margin: "0px" }}>
                <Language language={this.props.language} section="prayerSupportSubtitle" />
              </p>
              <div className="prayer-content">
                <Language language={this.props.language} section="prayerContent" mode="list" listSpace="5vw" />
              </div>
            </div>
            <div className="offering-support">
              <p className="offering-support-title" style={{ position: "relative", width: "100%", fontWeight: "bold", fontSize: "30px", textAlign: "left" }}>
                <Language language={this.props.language} section="offeringSupportTitle" />
              </p>
              <p className="offering-support-subtitle" style={{ position: "relative", width: "100%", fontWeight: "bold", fontSize: "15px", textAlign: "left", top: "-15px", margin: "0px" }}>
                <Language language={this.props.language} section="offeringSupportSubtitle" />
              </p>
              <div className="top-row">
                <img src={MCRDIcon} alt="mcrdIcon" style={{ width: "200px" }} />
              </div>
              <div className="bottom-row">
                <div className="bottom-row-column">
                  <img src={RHBIcon} alt="rhbIcon" style={{ width: "200px", marginBottom: "30px" }} />
                  <p>CAC MCR FUND</p>
                  <p>2121 5200 1015 14</p>
                </div>
                <div className="bottom-row-column">
                  <img src={QRCode} alt="qrCode" style={{ width: "200px" }} />
                  <div style={{ display: "flex", flexDirection: "row", margin: "10px" }}>
                    <img src={DuitNowIcon} alt="duitNowIcon" style={{ width: "30px", height: "30px" }} />
                    <img src={QRPayIcon} alt="qrPayIcon" style={{ width: "70px", height: "30px" }} />
                    <img src={BoostIcon} alt="boostIcon" style={{ width: "30px", height: "30px" }} />
                    <img src={ShopeeIcon} alt="shopeeIcon" style={{ width: "30px", height: "40px" }} />
                    <img src={TngIcon} alt="tngIcon" style={{ width: "30px", height: "30px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    this.setState({
      screenDimensions: {
        height: window.innerHeight,
        width: window.innerWidth,
      },
    });
  }
  onImageLoad({ target: source }) {
    this.setState({
      dimensions: {
        height: source.height,
        width: source.width,
        width_height_ratio: source.width / source.height,
      },
    });
  }
}
export default GetInvolved;
